import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { UserSceneProps } from "../types";

/** Korak "Korisnički podaci": obrazac prijave s korisničkim imenom, pa uloge i poslovnica. */
const UserAccountScene: React.FC<UserSceneProps> = ({ user }) => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Prijava</div>
          <div className="text-sm font-bold text-slate-800 truncate">{user.fullName}</div>

          <div className="mt-4 space-y-3">
            <div>
              <div className="text-[0.6rem] font-semibold text-slate-500">Korisničko ime</div>
              <div className="mt-1 rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-[0.7rem] font-semibold text-slate-800 truncate">
                {user.userName}
              </div>
            </div>
            <div>
              <div className="text-[0.6rem] font-semibold text-slate-500">Lozinka</div>
              <div className="mt-1 rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-[0.7rem] tracking-[0.3em] text-slate-500">
                ••••••••
              </div>
            </div>
          </div>
          <div className="mt-4 rounded-md bg-blue-600 py-2 text-center text-[0.7rem] font-semibold text-white">Prijava</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Uloge</div>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {user.roleNames.slice(0, 4).map((role) => (
              <span key={role} className="px-2 py-0.5 rounded-full text-[0.6rem] font-semibold bg-blue-50 text-blue-700">
                {role}
              </span>
            ))}
          </div>
          <div className="mt-3 text-[0.65rem] text-slate-500 truncate">
            Poslovnica: <span className="font-semibold text-slate-700">{user.officeName}</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Uloga određuje pristup"
          subtitle="Svatko vidi samo svoj dio"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(UserAccountScene);
